/**
 * features.flags.js — Bascules de version V2 / V3.
 *
 * Strategie retenue : DUPLICATION ASSUMEE (strategie A).
 * - V3 ne depend jamais de V2. Chaque page/layout V3 recopie ce dont elle a besoin.
 * - Quand une page passe en V3, on bascule son flag a `true`.
 * - A la fin de la migration, supprimer les dossiers v2/ d'un coup, sans demelage.
 *
 * REGLE : aucun import croise entre les arbres v2 et v3.
 */

export const FLAGS = {
  // --- Shell / layout global (Menu, Header, AppShell) ---
  USE_V3_LAYOUT: true,

  // --- Pages client ---
  USE_V3_STORE_MANAGER: false,
  USE_V3_MY_REGION: true,
  USE_V3_MY_WAREHOUSE: true,
  USE_V3_HISTORIC: true,
  USE_V3_MY_ORDERS: true,
  USE_V3_ORGANISATION: true,
  USE_V3_INTEGRATION: true,
  USE_V3_PROFILE: false,
  
  USE_V3_MY_NETWORK: true,
  USE_V3_VIEW_BY_LOCATION: true,
  USE_V3_VIEW_BY_FLOW: true,

  // --- Pages admin ---
  USE_V3_ADMIN: false,

  // --- Pages partenaire ---
  USE_V3_INDUSTRIAL: false,
};

/**
 * Helper de selection de version pour le lazy loading dans routes.config.js.
 * @param {boolean} flag - flag de la feature
 * @param {Function} v3 - factory dynamic import V3
 * @param {Function} v2 - factory dynamic import V2
 */
export const pickVersion = (flag, v3, v2) => (flag ? v3 : v2);
